export default class Game extends Phaser.Game {
    public rewardStatus: boolean;
    constructor(config: Phaser.Types.Core.GameConfig) {
      super(config);
      
      // init code
      this.rewardStatus = false;
      window.constants["MOBILE_FLAG"] = !this.device.os.desktop;
    }

    public setRewardStatus(status) {
      this.rewardStatus = !!status;
    }

    public getRewardStatus() {
      return this.rewardStatus;
    }
    
    public resume() {
      if(!this.scene.isSleeping("MenuScene")) {
        this.scene.resume("MenuScene");
      } else if(!this.scene.isSleeping("GameScene")) {
        this.scene.resume("GameScene");
        if(this.sound.volume == 1) {
          this.sound.mute = false;
        }
      }
    }

    public pause() {
      if(!this.scene.isSleeping("MenuScene")) {
        this.scene.pause("MenuScene");
      } else if(!this.scene.isSleeping("GameScene")) {
        this.scene.pause("GameScene");
        if(this.sound.volume == 1) {
          this.sound.mute = true;
        }
      }
    }

  }